module.exports = __webpack_public_path__ + "static/media/project-costing.a3873bcc.svg";